import React, {useEffect, useState} from 'react';

// custom components
import { Text } from '../atoms';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const List = (props) => {

    const [STATE, SETSTATE] = useState(false)

    return (
        <ul>
            { props.list.map((item) => 
                <li><Text.Text>{item}</Text.Text></li>
            )}
        </ul>
    );
};


export default List;